export default {"src":"/_next/static/media/arrow-right.f0a34a66.svg","height":11,"width":11,"blurWidth":0,"blurHeight":0};